module.exports = __webpack_public_path__ + "static/media/task5Planet3.7e1667d0.png";